export default "__VITE_ASSET__byTIGdwC__"